// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#payload {\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  font-size: 1.6rem;\n}\n", ""]);
// Exports
module.exports = exports;
